import { all, takeEvery, call, put } from "redux-saga/effects";
import { create, remove } from "services/apis/credential";
import actions from "./actions";
import { toastr } from "react-redux-toastr";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* CREATE({ payload }) {
  const { body, filter } = payload;
  yield loading(true);

  const response = yield call(create, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        credentials: response,
        loading: false,
      },
    });

    yield put({ type: "connection/DETAIL", payload: filter });
    toastr.success("create succeeded", "created new credential!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DELETE({ payload }) {
  const { id, filter } = payload;
  yield loading(true);

  const response = yield call(remove, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: "connection/DETAIL", payload: filter });
    toastr.success("delete succeeded", "successfully deleted credential!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* CLEAR() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      credentials: {},
      loading: false,
    },
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CREATE, CREATE),
    takeEvery(actions.DELETE, DELETE),
    takeEvery(actions.CLEAR, CLEAR),
  ]);
}
